export default __webpack_public_path__ + "static/media/cl_national_front.834cdfaf.png";